import React from 'react';

export const IconAttach: React.FC = () => {
    return (
        <svg width='32' height='32' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='m22.24 12.42-8.52 8.52c-.25.25-.59.39-.94.39h-2.12c-.74 0-1.33-.6-1.33-1.33v-2.12c0-.35.14-.69.38-.95l9.38-9.59a5.2 5.2 0 0 1 7.37-.04l.1.1a5.26 5.26 0 0 1-.03 7.49c-3.14 3.08-7.45 7.37-9.92 9.83a6.65 6.65 0 0 1-4.71 1.95H7.99a4 4 0 0 1-4-4.01v-3.9c0-1.77.7-3.47 1.95-4.72l8.3-8.29'
                stroke='currentColor'
                strokeWidth='2.67'
                strokeLinejoin='round'
                strokeLinecap='round'
            />
        </svg>
    );
};
